import { ChangeDetectionStrategy, Component } from '@angular/core';
import { cards } from './x-cards';
import { IntroSectionComponent } from './intro-section/intro-section.component';
import { AiAssistantComponent } from './ai-assistant/ai-assistant.component';
import { PygXCardComponent } from '@pyg-shared/pyg-x-card/pyg-x-card.component';
import { BenefitsComponent } from './benefits/benefits.component';

@Component({
  selector: 'app-pygmalios-x',
  templateUrl: './pygmalios-x.component.html',
  styleUrls: ['./pygmalios-x.component.scss'],
  imports: [
    IntroSectionComponent,
    AiAssistantComponent,
    PygXCardComponent,
    BenefitsComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PygmaliosXComponent {
  public readonly cards = cards;
}
